module.exports = __webpack_public_path__ + "gitserver.png";